export default __webpack_public_path__ + "static/media/magistracy-people.0ac0f2d1.png";